import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from 'src/app/services/utils';
import { API_PARAMS_CONST, COMMON_CONSTANTS } from '../common/core/common.constants';
import { HttpCacheService } from './http-cache.service';

@Injectable({
  providedIn: 'root',
})
export class HelperUtilityService {

  constructor(private _cacheSvc: HttpCacheService) { }

  public getClientId() {
    if (environment.ENABLE_AHUB_FLOW && environment.ENABLE_RAHUB_FLOW) {
      const idpType = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE);
      if (idpType === COMMON_CONSTANTS.OKTA_KEY || idpType === COMMON_CONSTANTS.AZURE_KEY ) {
        return API_PARAMS_CONST.B2B_CLIENT_ID_TFB_AM_CARE;
      } else {
        return API_PARAMS_CONST.B2B_CLIENT_ID_TFB_AM_APP;
      }
    } else {
      return API_PARAMS_CONST.B2B_CLIENT;
    }
  }

  getOrgID() {
    if (environment.ENABLE_AHUB_FLOW && environment.ENABLE_RAHUB_FLOW) {
      return this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ORG_ID_KEY);
    } else {
      return environment.B2B_ORG_ID;
    }
  }

  getRecordedSourceFromPnp(){
    const recordedSourceValue = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.PNP_PERSISTED_CONTEXT);
    if(recordedSourceValue !== null || recordedSourceValue !== undefined){
      const pnpPersContext = JSON.parse(recordedSourceValue);
      return  pnpPersContext?.entitlementAuthType ? pnpPersContext.entitlementAuthType  : '';
    }
  }

  getBanFromPnpContext() {
    return JSON.parse(
      this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.PNP_PERSISTED_CONTEXT) || '{}'
    )?.ban || '';
  }

  isDataExistInTEA(){
    return this.getRecordedSourceFromPnp() == COMMON_CONSTANTS.LH_TEXT ;
  }

  isLhUser() {
    const euiTokenDataAdGroups:[] = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA) || '{}')?.AD_Groups;
    const isPureLhUser = euiTokenDataAdGroups?.every((item:any)=>{
      return COMMON_CONSTANTS.LH_AD_GROUPS.includes(item?.toLowerCase());
    });
    return isPureLhUser || this.isDataExistInTEA() ;
  }

  getUserId() {
    const authType = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE);
    if (environment.ENABLE_AHUB_FLOW && environment.ENABLE_RAHUB_FLOW) {
      if (authType === COMMON_CONSTANTS.IAM_KEY) {
        return this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.IAM_USER_ID);
      } else {
        return this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.USER_ID);
      }
    } else {
      return environment.AHUB_USER_ID;
    }
  }

  getTransactionID() {
    const transactionID = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.TRANSACTIONID);

    if (isNullOrUndefined(transactionID) || transactionID === '') {
      const now = new Date();
      this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.TRANSACTIONID, now.valueOf());
      this.getTransactionID();
    }
    return transactionID;
  }

  IsIOTRole() {
    const role = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ROLE);
    if (role == COMMON_CONSTANTS.IOT && environment.ENABLE_CW_NON_IOT && environment.ENABLE_AHUB_FLOW && environment.ENABLE_IOT) {
      return true;
    } else {
      return false;
    }
  }

  getAuthType() {
    const type = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE);
    if (type === COMMON_CONSTANTS.OKTA_KEY) {
      return COMMON_CONSTANTS.OKTA_KEY;
    }else if(type === COMMON_CONSTANTS.AZURE_KEY){
      return COMMON_CONSTANTS.AZURE_KEY
    } else {
      return COMMON_CONSTANTS.IAM_KEY
    }
  }

  getAuthToken() {
    return this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ID_TOKEN) || '';
  }

  getUserIdfromPnpContext(){
    return !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.PNP_PERSISTED_CONTEXT))? this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.PNP_PERSISTED_CONTEXT) : '';
  }

  getEURoleFromSessionStorage() {
    let role = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ROLE);
    if (isNullOrUndefined(role)) {
      role = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ROLENEW);
    }
    return role;
  }

  isEndUser() {
    const role = this.getEURoleFromSessionStorage();
    if (role === COMMON_CONSTANTS.END_USER && environment.ENABLE_END_USER) {
      return true;
    }
    else {
      return false;
    }
  }
}
